import axios from "axios";
import { BASE_URL } from "@/env";

export default async function setTokenMuni() {
  try {
    let refresh = localStorage.getItem("refreshToken");

    if (!refresh) {
      console.log("No hay refreshToken en localStorage");
      return false;
    }

    const apiClient = axios.create({
      baseURL: BASE_URL,
      headers: {
        "auth-header": localStorage.getItem("token"),
      },
    });

    const response = await apiClient.post("/refresh-token-muni", {
      refreshToken: refresh,
    });

    if (response.status === 200) {
      const newToken = response.data.Token;
      localStorage.setItem("token", newToken);
      return true;
    } else {
      console.log("Error al refrescar token, estado:", response.status);
      return false;
    }
  } catch (error) {
    console.log("Error al renovar el token:", error);
    return false;
  }
}
